/**
 * API Routes for AgentOS integration
 */

const APIRoutes = {
    // Team routes
    TeamRun: (baseUrl: string, teamId: string) => `${baseUrl}/teams/${teamId}/runs`,

    // Agent routes  
    AgentRun: (baseUrl: string) => `${baseUrl}/agents/{agent_id}/runs`,
    
    // Skills-based agent route (supports model selection)
    // AgentOS is mounted at root, so the correct path is /agentos/skills/stream
    SkillsStream: (baseUrl: string) => `${baseUrl}/agentos/skills/stream`,
    SignalBuilderDraft: (baseUrl: string) => `${baseUrl}/agentos/skills/signal-builder/draft`,
};

export default APIRoutes;
